import type { IBiometricDataLog, IBiometricDataReportDto } from 'src/types/hr_ticket/biometricDataLog.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'hr/biometric-data-logs';

// Lấy danh sách chấm công theo tháng/năm và mã nhân viên
export const getBiometricLogsPaging = async (month: number, year: number, employeeCode: string) => {
  return await http.get<IBiometricDataLog[]>(`${controller}`, {
    params: {
      month,
      year,
      employeeCode
    }
  });
};

// Lấy danh sách chấm công theo khoảng thời gian và mã nhân viên
export const getBiometricsDataLog = async (fromDate: Date, toDate: Date, employeeCode?: string) => {
  return await http.get<IBiometricDataLog[]>(`${controller}/period`, {
    params: {
      fromDate,
      toDate,
      employeeCode
    }
  });
};

// Lấy danh sách quên chấm công
export const getPrintFingerForgetting = async (employeeCode?: string) => {
  return await http.get<Date[]>(`${controller}/forgot-io`, { params: { employeeCode: employeeCode } });
};

// Báo cáo chấm công (orderBy = "{field} {order}", vd: "DepartmentName asc")
export const getBiometricDataLogReport = async (
  fromDate: string,
  toDate: string,
  departmentId?: number,
  employeeId?: number,
  productionUnitId?: number,
  viewAllDepartments?: boolean,
  orderBy?: string
) => {
  return await http.get<IBiometricDataReportDto>(`${controller}/report`, {
    params: {
      fromDate,
      toDate,
      departmentId,
      employeeId,
      productionUnitId,
      viewAllDepartments,
      orderBy
    }
  });
};
